import { observer } from 'mobx-react-lite'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { SurveysProvider, useSurveysContext } from 'pages/surveys/context/surveysContext'
import { SurveysPageEmpty } from 'pages/surveys/ui/SurveysPageEmpty/SurveysPageEmpty'

const Surveys = observer(() => {
  const { isLoading, empty } = useSurveysContext()

  if (isLoading) {
    return <SpinnerLoader ariaLabel={'surveysPage'} />
  }

  if (empty) {
    return <SurveysPageEmpty />
  }

  return <FullPageWrapper></FullPageWrapper>
})

export const SurveysPage = () => (
  <SurveysProvider>
    <Surveys />
  </SurveysProvider>
)
